import type { PostApiV5UserJourneyStepsBody } from '@liscio/api';

import { WHAT_TO_DO_TODAY_SOURCE, WHAT_TO_DO_TODAY_SURFACE } from './constants';
import type { DashboardActionId } from './dashboardActions';

export const DASHBOARD_ACTIVATION_JOURNEY_KEY = 'dashboard_activation';

const ACTION_TO_STAGE_KEY = {
  upload_file: 'file_uploaded',
  smart_tax_delivery: 'tax_delivery_started',
  smart_tax_organizer: 'smart_tax_organizer_started',
  send_message: 'message_sent',
} satisfies Record<DashboardActionId, string>;

export function getStageKeyForAction(actionId: DashboardActionId): string {
  return ACTION_TO_STAGE_KEY[actionId];
}

interface BuildJourneyStepPayloadParams {
  actionId: DashboardActionId;
  stageKey?: string;
  targetType?: 'Contact' | 'Account' | 'Document' | 'WfRequest';
  targetId?: number;
  metadata?: Record<string, unknown>;
}

export function buildJourneyStepPayload({
  actionId,
  stageKey,
  targetType,
  targetId,
  metadata,
}: BuildJourneyStepPayloadParams): PostApiV5UserJourneyStepsBody {
  const payloadMetadata = {
    ...(metadata ?? {}),
    ...(targetType != null && targetId != null
      ? { target_type: targetType, target_id: targetId }
      : {}),
  };

  return {
    journey_key: DASHBOARD_ACTIVATION_JOURNEY_KEY,
    stage_key: stageKey ?? getStageKeyForAction(actionId),
    status: 'completed',
    source: WHAT_TO_DO_TODAY_SOURCE,
    surface: WHAT_TO_DO_TODAY_SURFACE,
    ...(Object.keys(payloadMetadata).length > 0 ? { metadata: payloadMetadata } : {}),
  };
}
